
import CardSend from "../../../assets/filled/CardSend.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function CardSendIcon({ className, dataTestid = "CardSendIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <CardSend data-testid={dataTestid} className={classes} {...rest} />
  );
}
